import request from "../request";
import Url from "../url/common";

const getRoot = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.get(prefix + Url.root + path, data, options);
};
const postRoot = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.root + path, data, options);
};
const login = ({ prefix = "", path = "", data, options = {} } = {}) => {
  return request.post(prefix + Url.login + path, data, options);
};

export default {
  getRoot,
  postRoot,
  login,
};
